const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 473.658 473.658",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A2D4DE"
    },
    cx: 236.829,
    cy: 236.829,
    r: 236.829
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6CC077"
    },
    d: "M404.288,69.347c92.488,92.488,92.495,242.446-0.007,334.941c-92.48,92.488-242.446,92.488-334.934,0 L404.288,69.347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M445.79,125.333c-1.81-3.388-3.695-6.728-5.669-10.007 C220.85,200.753,124.016,406.517,110.629,437.201c3.235,2.046,6.514,4.001,9.854,5.894 C130.561,419.553,225.476,210.356,445.79,125.333z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 40) scale(0.8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CB2B3E"
    },
    d: "M237.506,80.252c-57.665,0-104.41,46.745-104.41,104.395c0,75.94,98.531,177.478,107.39,177.478 c8.859,0,101.399-110.487,101.399-177.478C341.886,126.997,295.156,80.252,237.506,80.252z M237.001,219.545 c-22.636,0-40.967-17.838-40.967-39.857s18.332-39.872,40.967-39.872c22.628,0,40.967,17.849,40.967,39.872 S259.629,219.545,237.001,219.545z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#982E40"
    },
    d: "M240.486,363.994c-9.218,0-109.26-102.618-109.26-179.348c0-58.592,47.676-106.265,106.279-106.265 c58.585,0,106.25,47.672,106.25,106.265C343.755,251.264,250.673,363.994,240.486,363.994z M237.506,82.122 c-56.539,0-102.54,45.993-102.54,102.525c0,76.217,96.833,173.768,105.502,175.593c8.863-2.285,99.548-109.178,99.548-175.593 C340.016,128.115,294.03,82.122,237.506,82.122z M237.001,221.414c-23.619,0-42.837-18.72-42.837-41.726 c0-23.021,19.218-41.741,42.837-41.741s42.837,18.72,42.837,41.741C279.838,202.694,260.62,221.414,237.001,221.414z  M237.001,141.686c-21.559,0-39.098,17.049-39.098,38.002c0,20.949,17.539,37.987,39.098,37.987 c21.563,0,39.098-17.041,39.098-37.987C276.099,158.731,258.56,141.686,237.001,141.686z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.4a033327170d4c2c45ef4433bb4185ef.svg";
export { ForwardRef as ReactComponent };